module.exports = __webpack_public_path__ + "static/img/przybornik_zakoncz.e1e851ed.png";